import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import { IconSizes } from '../../components/foundations/Icon';
import Button from '../../components/atoms/Button';
import { STARTER_CARDS, TRANSLATION_KEY, pickStarterCard, trackStarterCardClick } from '../constants';
import css from './WatchlistExamplesStrip.css';

const EXAMPLES_KEY = `${TRANSLATION_KEY}.EXAMPLES`;

const WatchlistExamplesStrip = ({ onPick, translate }) => {
    const [expanded, setExpanded] = useState(false);

    const expandFromPill = card => {
        trackStarterCardClick(card, translate, { is_pill: true });
        setExpanded(true);
    };

    return (
        <div className={css.strip}>
            <div className={css.header}>
                <span className={css.label}>
                    <Translate id={`${EXAMPLES_KEY}.LABEL`} />
                </span>
                <span className={css.pills}>
                    {STARTER_CARDS.map(card => (
                        <button key={card.id} type="button" className={css.pill} onClick={() => expandFromPill(card)}>
                            <Translate id={card.titleKey} />
                        </button>
                    ))}
                </span>
                <Button
                    type="link"
                    className={css.toggle}
                    Icon={expanded ? 'chevron-up' : 'chevron-down'}
                    iconSize={IconSizes.XX_SMALL}
                    iconClass={css.toggleIcon}
                    iconLocation="right"
                    ariaExpanded={expanded}
                    onClick={() => setExpanded(prev => !prev)}
                >
                    <Translate id={`${EXAMPLES_KEY}.${expanded ? 'HIDE' : 'SHOW_ALL'}`} />
                </Button>
            </div>
            {expanded && (
                <div className={css.cards}>
                    {STARTER_CARDS.map(card => (
                        <button
                            key={card.id}
                            type="button"
                            className={css.card}
                            onClick={() => pickStarterCard(card, onPick, translate)}
                        >
                            <span className={css.cardTitle}>
                                <Translate id={card.titleKey} />
                            </span>
                            <span className={css.cardPrompt}>
                                <Translate id={card.promptKey} />
                            </span>
                            <span className={css.cardCta}>
                                <Translate id={`${EXAMPLES_KEY}.USE_THIS`} />
                            </span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

WatchlistExamplesStrip.propTypes = {
    onPick: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(WatchlistExamplesStrip);
